<template>
  <div>
    <div class="label">Порядок</div>
    <div class="d-flex align-center ga-2">
      <v-btn
        :readonly="value === 1"
        border
        icon
        variant="text"
        @click="emit('decrement')">
        <v-icon icon="mdi-arrow-left"></v-icon>
      </v-btn>

      <div class="route-counter d-flex align-center justify-center">
        <span class="font-weight-bold">{{ value }}</span>
      </div>

      <v-btn
        :readonly="value === length"
        border
        icon
        variant="text"
        @click="emit('increment')">
        <v-icon icon="mdi-arrow-right"></v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: 'QueueCounter',
})

defineProps<{
  value: number
  length: number
}>()

const emit = defineEmits<{
  decrement: []
  increment: []
}>()
</script>

<style lang="scss" scoped>
.route-counter {
  width: 44px;
  height: 44px;
  border: 2px solid #185fa5;
  border-radius: 50%;
  color: #185fa5;
}
</style>
